import { PastUsed } from '@/domain/swing/faq/PastUsed';

export default function PastUsedPage() {
  return (
    <PastUsed />    
  );
}